import React from "react";
import { Route } from "react-router-dom";

// Lazy routes keep the wedding pages, fonts and lightbox out of the main D&D bundle.
const page = (load) => () =>
  load().then((module) => ({ Component: module.default }));

export default () => [
  // The D&D group's puzzle stands apart from the wedding pages: no header, no paper.
  <Route
    path="/wedding/three"
    key="wedding/three"
    lazy={page(() => import("./three/ThreePage"))}
  />,
  <Route
    path="/wedding"
    key="wedding"
    lazy={page(() => import("./WeddingLayout"))}
  >
    <Route
      index
      key="wedding/index"
      lazy={page(() => import("./home/WeddingHome"))}
    />
    <Route
      path="photos"
      key="wedding/photos"
      lazy={page(() => import("./gallery/Gallery"))}
    />
    <Route
      path="rsvp"
      key="wedding/rsvp"
      lazy={page(() => import("./rsvp/RsvpPage"))}
    />
    <Route
      path="rsvp/:token"
      key="wedding/rsvp/token"
      lazy={page(() => import("./rsvp/RsvpStatus"))}
    />
    <Route
      path="admin"
      key="wedding/admin"
      lazy={page(() => import("./admin/RsvpAdmin"))}
    />
    <Route
      path="admin/status"
      key="wedding/admin/status"
      lazy={page(() => import("./admin/StatusBoard"))}
    />
    <Route
      path="*"
      key="wedding/not-found"
      lazy={page(() => import("./WeddingNotFound"))}
    />
  </Route>,
];
